export default function CollapseTwo() {
    return (
        <div className="flex flex-col my-2 gap-4">
            <p>Indicado como auxiliar para el tratamiento de la demencia leve a moderadamente grave del tipo Alzheimer.</p>
            <img src={"./imgs/Sudonnez-box.png"} alt="Sudonnez-box.png" className="w-full"/>
        </div>
    );
}